import React, { useEffect, useState } from 'react'
import moment from 'moment/moment';
//Components
import MainCard from 'components/MainCard/MainCard';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';
import FiltroPrefeitura from 'views/Shared/FiltroPrefeitura';
//Contants
import { actionsTable } from '../../../../constants/MaterialTable';
//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';
//Api
import gerador_api from 'api/gerador_api';
//Context
import { useAuth } from '../../../../context/auth';
import { getSessionCookie } from 'helpers/cookies';
import AnaliseGeradorLocalidade from './AnaliseGeradorLocalidade';

export default function GeradoresAguardandoAprovacaoCadastro({ geradoresLocalidadesPendentes, handleReturn }) {
    const { setLoading } = useAuth();

    //Estado de controle para exibição da tela
    const [ficha, setFicha] = useState(null);

    //Dados do usuario logado
    const usuario = getSessionCookie();

    // Estado que guarda os geradores
    const [geradores, setGeradores] = useState([]);

    // Estado para carregar os dados do gerador selecionado na lista
    const [fichaGerador, setFichaGerador] = useState(null);
    
    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);
    const handlePrefeitura = (value) => {
        setPrefeitura_Id(value);
        if (!!usuario)
            loadGeradores(value);
    }
    //Cabeçalhos da tabela de listagem de Geradores
    const [headersTabela, setHeadersTabela] = useState([
        { value: "CPF / CNPJ", objectValue: "cpfcnpj", align: "left", },
        { value: "Fantasia", objectValue: "fantasia", align: "left" },
        { value: "Razão", objectValue: "razao", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
    ]);
    const loadGeradores = (value) => {
        setLoading(true);
        gerador_api.GetList(value).then(response => {
            response.data = response.data.map(gerador => {
                gerador.cpfcnpj = mascaras.cpfcnpjMask(gerador.cpfcnpj);
                return gerador;
            })
            setGeradores(response.data.filter(gerador => geradoresLocalidadesPendentes.some(g => g.tbGerador_Id == gerador.id)));
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    const getFichaGerador = (tbGerador_id) => {
        setLoading(true);
        gerador_api.GetItem(tbGerador_id).then(response => {
            if (response.data.tbPrefeituras_id) {
                response.data.tbPrefeituras_id = response.data.tbPrefeituras_id.toString();
            }
            if (response.data.tbSetores_Id) {
                response.data.tbSetores_Id = response.data.tbSetores_Id.toString();
            }
            if (response.data.tbSegmentos_Id) {
                response.data.tbSegmentos_Id = response.data.tbSegmentos_Id.toString();
            }
            if (response.data.dataValidade) {
                response.data.dataValidade = moment(response.data.dataValidade).format("YYYY-MM-DD")
            }
            response.data.localidades = response.data.localidades.map(localidade => {
                if (localidade.localidadePadrao) {
                    localidade.principal = "Sim";
                } else {
                    localidade.principal = "Não";
                }
                localidade.contratos = localidade.contratos.map(contrato => {
                    Object.keys(contrato).map(key => {
                        if (!contrato[key] === null) {
                            contrato[key] = "";
                        }
                    });
                    contrato.quantidadeContratada = contrato.quantidadeContratada ? contrato.quantidadeContratada.toString().replace(".", ",") : "";
                    return contrato;
                });
                return localidade;
            })
            setFichaGerador(response.data)
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
        
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];

    useEffect(() => {
        if (ficha) {
            getFichaGerador(ficha);
        }
    }, [ficha]);

    if(fichaGerador)
    {
        return <AnaliseGeradorLocalidade
        btnVoltar={() => {
            setFicha(null);
            setFichaGerador(null);
        }}
        geradorSelecionado={fichaGerador}
    />
    }

    return (
        <div>
            <MainCard
                noCard
                title={"Geradores Aguardando Aprovação de Cadastro"}
                btnVoltarInTop={handleReturn}
            >
                <FiltroPrefeitura handleValue={handlePrefeitura} />
                <div className={`w-100 `}>
                    <div className='mt-4'>
                        <TabelaListagem
                            headers={headersTabela}
                            items={geradores}
                            actions={actions}
                            title="Lista de Geradores"
                            options={{ print: false, search: true, pagination: true }}
                        />
                    </div>
                </div>
            </MainCard >
        </div>
    )
}